import { Injectable } from '@angular/core';
import { CanDeactivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import { SharedService } from 'app/shared/services/shared.service';

export interface CanComponentDeactivate {
  canDeactivate: () => Observable<boolean> | Promise<boolean> | boolean;
  hasChanges: () => boolean;
}

@Injectable()
export class ChangesGuard implements CanDeactivate<CanComponentDeactivate> {
  constructor(public sharedService: SharedService) {}

  canDeactivate(
    component: CanComponentDeactivate,
    currentRoute: ActivatedRouteSnapshot,
    currentState: RouterStateSnapshot,
    nextState: RouterStateSnapshot
  ) {
    let allowed = true;
    this.sharedService.navigateAwayUrl = nextState.url.split('?')[0];
    this.sharedService.navigateAwayQueryParams = nextState.root.queryParams;
    if (component) {
      if (typeof component.hasChanges === 'function' && component.hasChanges()) {
        if (!this.sharedService.navigateAwayModalState) {
          this.sharedService.showNavigateAwayModal();
          allowed = false;
        } else {
          allowed = this.sharedService.navigateAwayConfirmation;
        }
      }
    }
    return allowed;
  }
}
